// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    padding: 50px 60px !important;
    font-size: 16px;
    text-align: center;
    margin: 0px auto !important;
}

.footer--app {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding-top: 40px !important;
    padding-bottom: 40px !important;
    max-width: 1200px;
}

.footer-trust-strip {
    margin-bottom: 32px;
}

.footer-trust-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    text-align: left;
}

.footer-trust-item {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    margin: 0;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid transparent;
}

.footer-trust-icon {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    display: block;
}

.footer-trust-item-icon {
    flex-shrink: 0;
    line-height: 0;
}

.footer-trust-item-body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.footer-trust-item-title {
    font-family: "Montserrat", "Questrial", sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.3;
}

.footer-trust-item-text {
    font-size: 13px;
    line-height: 1.45;
}

/* Dashboard (dark shell) */
.footer-trust-strip--dark .footer-trust-item {
    background: rgba(0, 0, 0, 0.22);
    border-color: rgba(255, 255, 255, 0.06);
}

.footer-trust-strip--dark .footer-trust-item-title {
    color: rgb(239, 239, 239);
}

.footer-trust-strip--dark .footer-trust-item-text {
    color: rgba(197, 197, 197, 0.88);
}

.footer-trust-strip--dark .footer-trust-item-icon {
    color: rgba(192, 159, 83, 0.95);
}

.footer-app-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.footer--app .footer-copyright {
    margin: 0;
    color: rgba(197, 197, 197, 0.85);
    font-size: 14px;
}

.footer-logo--on-dark {
    filter: brightness(0) invert(1);
    opacity: 0.92;
}

/* Login / signup page footer — matches .int-login (Login.css) */
.footer.lp-footer {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100% !important;
    text-align: center;
    color: #e8e8e8;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    background: linear-gradient(
        168deg,
        #0a0a0c 0%,
        #0a0a0c 35%,
        #080809 100%
    );
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.lp-footer__accent {
    width: 42%;
    max-width: 200px;
    height: 3px;
    margin: 0 auto;
    border-radius: 0 0 8px 8px;
    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.9), transparent);
    pointer-events: none;
}

.lp-footer__inner {
    max-width: 640px;
    margin: 0 auto;
    padding: clamp(28px, 5vw, 44px) clamp(20px, 5vw, 48px) clamp(36px, 6vw, 52px);
    box-sizing: border-box;
}

.footer-trust-strip--login {
    margin-bottom: 28px;
}

.footer-trust-strip--login .footer-trust-item {
    background: rgba(0, 0, 0, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 10px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.footer-trust-strip--login .footer-trust-item-title {
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #e2e2e2;
}

.footer-trust-strip--login .footer-trust-item-text {
    font-size: 0.8125rem;
    line-height: 1.5;
    color: #a3a3a3;
}

.footer-trust-strip--login .footer-trust-item-icon {
    color: #d4b76a;
}

.lp-footer__nav {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 28px 40px;
    margin-top: 8px;
    text-align: left;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
}

.lp-footer__nav-col {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.lp-footer__nav-title {
    margin: 0 0 4px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #c0a053;
}

.lp-footer__link {
    font-size: 0.875rem;
    font-weight: 500;
    color: #8f9aad;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: color 0.2s ease, border-color 0.2s ease;
}

.lp-footer__link:hover {
    color: #c0a053;
    border-bottom-color: rgba(192, 159, 83, 0.45);
}

.lp-footer__brand {
    margin-top: 36px;
    padding-top: 28px;
    border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.lp-footer__logo {
    display: block;
    width: 100%;
    max-width: min(280px, 100%);
    height: auto;
    margin: 0 auto;
    object-fit: contain;
    filter: brightness(0) invert(1);
    opacity: 0.92;
}

.lp-footer__lead {
    margin: 18px auto 10px;
    max-width: 36em;
    font-size: 0.875rem;
    line-height: 1.55;
    color: #a3a3a3;
}

.lp-footer__copyright {
    margin: 0;
    font-size: 0.65rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #5c6570;
    line-height: 1.45;
}

.footer-logo {
    width: 300px;
    object-fit: contain;
    margin: 0 auto;
}

@media screen and (max-width: 900px) {
    .footer-trust-list {
        grid-template-columns: 1fr;
    }

    .lp-footer__nav {
        grid-template-columns: 1fr;
        text-align: center;
        max-width: none;
    }

    .lp-footer__nav-col {
        align-items: center;
    }

    .footer {
        padding: 32px 24px !important;
    }

    .footer.lp-footer {
        padding: 0 !important;
    }

    .footer.lp-footer .lp-footer__inner {
        padding-left: 20px;
        padding-right: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Style.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;IAC/C,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;AACjB;;AAEA,gEAAgE;AAChE;IACI,qBAAqB;IACrB,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,gGAAgG;IAChG;;;;;KAKC;IACD,+CAA+C;IAC/C,mDAAmD;AACvD;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,qFAAqF;IACrF,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,6EAA6E;IAC7E,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,2CAA2C;IAC3C,mBAAmB;IACnB,mDAAmD;AACvD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,oCAAoC;IACpC,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ","sourcesContent":[".footer {\n    padding: 50px 60px !important;\n    font-size: 16px;\n    text-align: center;\n    margin: 0px auto !important;\n}\n\n.footer--app {\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n    max-width: 1200px;\n}\n\n.footer-trust-strip {\n    margin-bottom: 32px;\n}\n\n.footer-trust-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 16px;\n    text-align: left;\n}\n\n.footer-trust-item {\n    display: flex;\n    gap: 14px;\n    align-items: flex-start;\n    margin: 0;\n    padding: 14px 16px;\n    border-radius: 12px;\n    border: 1px solid transparent;\n}\n\n.footer-trust-icon {\n    width: 22px;\n    height: 22px;\n    flex-shrink: 0;\n    display: block;\n}\n\n.footer-trust-item-icon {\n    flex-shrink: 0;\n    line-height: 0;\n}\n\n.footer-trust-item-body {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.footer-trust-item-title {\n    font-family: \"Montserrat\", \"Questrial\", sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    line-height: 1.3;\n}\n\n.footer-trust-item-text {\n    font-size: 13px;\n    line-height: 1.45;\n}\n\n/* Dashboard (dark shell) */\n.footer-trust-strip--dark .footer-trust-item {\n    background: rgba(0, 0, 0, 0.22);\n    border-color: rgba(255, 255, 255, 0.06);\n}\n\n.footer-trust-strip--dark .footer-trust-item-title {\n    color: rgb(239, 239, 239);\n}\n\n.footer-trust-strip--dark .footer-trust-item-text {\n    color: rgba(197, 197, 197, 0.88);\n}\n\n.footer-trust-strip--dark .footer-trust-item-icon {\n    color: rgba(192, 159, 83, 0.95);\n}\n\n.footer-app-bottom {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n}\n\n.footer--app .footer-copyright {\n    margin: 0;\n    color: rgba(197, 197, 197, 0.85);\n    font-size: 14px;\n}\n\n.footer-logo--on-dark {\n    filter: brightness(0) invert(1);\n    opacity: 0.92;\n}\n\n/* Login / signup page footer — matches .int-login (Login.css) */\n.footer.lp-footer {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100% !important;\n    text-align: center;\n    color: #e8e8e8;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n    background: linear-gradient(\n        168deg,\n        #0a0a0c 0%,\n        #0a0a0c 35%,\n        #080809 100%\n    );\n    border-top: 1px solid rgba(255, 255, 255, 0.07);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.lp-footer__accent {\n    width: 42%;\n    max-width: 200px;\n    height: 3px;\n    margin: 0 auto;\n    border-radius: 0 0 8px 8px;\n    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.9), transparent);\n    pointer-events: none;\n}\n\n.lp-footer__inner {\n    max-width: 640px;\n    margin: 0 auto;\n    padding: clamp(28px, 5vw, 44px) clamp(20px, 5vw, 48px) clamp(36px, 6vw, 52px);\n    box-sizing: border-box;\n}\n\n.footer-trust-strip--login {\n    margin-bottom: 28px;\n}\n\n.footer-trust-strip--login .footer-trust-item {\n    background: rgba(0, 0, 0, 0.22);\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    border-radius: 10px;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.footer-trust-strip--login .footer-trust-item-title {\n    font-family: inherit;\n    font-size: 0.875rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: #e2e2e2;\n}\n\n.footer-trust-strip--login .footer-trust-item-text {\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: #a3a3a3;\n}\n\n.footer-trust-strip--login .footer-trust-item-icon {\n    color: #d4b76a;\n}\n\n.lp-footer__nav {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 28px 40px;\n    margin-top: 8px;\n    text-align: left;\n    max-width: 420px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.lp-footer__nav-col {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.lp-footer__nav-title {\n    margin: 0 0 4px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    color: #c0a053;\n}\n\n.lp-footer__link {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #8f9aad;\n    text-decoration: none;\n    border-bottom: 1px solid transparent;\n    transition: color 0.2s ease, border-color 0.2s ease;\n}\n\n.lp-footer__link:hover {\n    color: #c0a053;\n    border-bottom-color: rgba(192, 159, 83, 0.45);\n}\n\n.lp-footer__brand {\n    margin-top: 36px;\n    padding-top: 28px;\n    border-top: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.lp-footer__logo {\n    display: block;\n    width: 100%;\n    max-width: min(280px, 100%);\n    height: auto;\n    margin: 0 auto;\n    object-fit: contain;\n    filter: brightness(0) invert(1);\n    opacity: 0.92;\n}\n\n.lp-footer__lead {\n    margin: 18px auto 10px;\n    max-width: 36em;\n    font-size: 0.875rem;\n    line-height: 1.55;\n    color: #a3a3a3;\n}\n\n.lp-footer__copyright {\n    margin: 0;\n    font-size: 0.65rem;\n    font-weight: 500;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #5c6570;\n    line-height: 1.45;\n}\n\n.footer-logo {\n    width: 300px;\n    object-fit: contain;\n    margin: 0 auto;\n}\n\n@media screen and (max-width: 900px) {\n    .footer-trust-list {\n        grid-template-columns: 1fr;\n    }\n\n    .lp-footer__nav {\n        grid-template-columns: 1fr;\n        text-align: center;\n        max-width: none;\n    }\n\n    .lp-footer__nav-col {\n        align-items: center;\n    }\n\n    .footer {\n        padding: 32px 24px !important;\n    }\n\n    .footer.lp-footer {\n        padding: 0 !important;\n    }\n\n    .footer.lp-footer .lp-footer__inner {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
